import AfterEmployeeCreationSchedulingStrategyEditor from "../../../pages/actionModules/ActionModuleEditor/SchedulingStrategyEditor/AfterEmployeeCreationSchedulingStrategyEditor";
import DefinedBySubtypeSchedulingStrategyEditor from "../../../pages/actionModules/ActionModuleEditor/SchedulingStrategyEditor/DefinedBySubtypeSchedulingStrategyEditor";
import { SchedulingStrategyDefinition } from "../actionModule";
import { SchedulingStrategyType } from "./schedulingStrategyType";

export const DefinedBySubtypeSchedulingStrategy: SchedulingStrategyDefinition = {
    name: "actionModules.schedulingStrategy.definedBySubtype.name",
    defaultValue: {},
    type: SchedulingStrategyType.DefinedBySubtypeSchedulingStrategy,
    editor: () => <DefinedBySubtypeSchedulingStrategyEditor />
};